import Sentry from 'lib/sentry';

const initialState = {
  announcements: {
    list: [],
    isCloseable: false,
  },
};

const getters = {
  getAnnouncements: (state) => state.announcements,
};

const actions = {
  fetchAnnouncements({commit, rootState}) {
    if (rootState.dataServer?.config?.announcements) {
      commit('setAnnouncement', rootState.dataServer.config.announcements);
      return;
    }

    return this.$api
      .getNeoConfig({id: ['edukarier-announcement-config']})
      .then(({data}) => {
        commit('setAnnouncement', data[0].data);
      })
      .catch((e) => {
        commit('setAnnouncementError', {
          isCloseable: false,
          list: [],
        });
        Sentry.log('fetchAnnouncements', e);
      });
  },
};

const mutations = {
  setAnnouncement(state, data) {
    state.announcements.list = data.announcements;
    state.announcements.isCloseable = data.closeable;
  },
  setAnnouncementError(state, data) {
    state.announcements = data;
  },
};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
